import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Tabs from 'react-bootstrap/esm/Tabs';
import Tab from 'react-bootstrap/Tab';
import Form from 'react-bootstrap/Form';
import { Table } from 'react-bootstrap';
// others
import Select from 'react-select'
import { minedexCommodoties, minedexTargetComodotiy, minedexSiteType } from './MinedexTypeData';
import { createSingleMinedexPopupTable, lookupSingleSiteCode } from './MinedexOverlay';
// The legend draws the same symbols the map registers, so the two cannot drift.
import { minedexSymbolDataUrl } from './dmirsSymbols';
import * as turf from "@turf/turf";
import {
    FilterSection, FilterGroup, Chip, ChipRow, ChipMultiSelect, filterStyles,
} from '../filters/FilterControls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

export const getMinedexCommodityCategoryFilterDefaults = () => {
    return [{ "label": "PRECIOUS METAL", "value": "PRECIOUS METAL" }]
}

export const getMinedexTargetCategoryFilterDefaults = () => {
    return [{ "label": "GOLD", "value": "GOLD" }]
}

export const getMinedexSiteTypeDefaults = () => {
    const out = minedexSiteType.map((e) => {
        return { label: e, value: e }
    });

    return out;
}

export function MinedexQueryTool({ minedexFilters, setMinedexFilters, goldfindermap, setMinedexPopup, setShowMinedexPopup }) {

    // Target commodity has ~50 entries. Chips are right for the short lists but
    // fifty of them is a wall, so this one stays a searchable multi-select -
    // repainted in the gf palette so it does not read as stock Bootstrap.
    const SelectCustomStyles = {
        // https://codesandbox.io/p/sandbox/react-select-valuecontainer-with-max-height-17b26?file=%2Fsrc%2FApp.js%3A28%2C5
        valueContainer: (base) => ({ ...base, maxHeight: 200, overflowY: "auto", padding: '2px 8px' }),
        control: (base, state) => ({
            ...base,
            minHeight: 38,
            borderRadius: 10,
            backgroundColor: 'var(--gf-surface, #FFFFFF)',
            borderColor: state.isFocused
                ? 'var(--gf-primary-400, #FD7218)'
                : 'var(--gf-border-color, #E5E7EB)',
            boxShadow: state.isFocused ? '0 0 0 3px var(--gf-primary-100, #FFE6D4)' : 'none',
            ':hover': { borderColor: 'var(--gf-primary-300, #FFA471)' },
        }),
        multiValue: (base) => ({
            ...base,
            borderRadius: 8,
            backgroundColor: 'var(--gf-primary-50, #FFF4ED)',
            border: '1px solid var(--gf-primary-400, #FD7218)',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: 'var(--gf-primary-500, #E65A00)',
            fontSize: '12px',
            fontWeight: 600,
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: 'var(--gf-primary-500, #E65A00)',
            borderRadius: '0 7px 7px 0',
            ':hover': { backgroundColor: 'var(--gf-primary-100, #FFE6D4)' },
        }),
        option: (base, state) => ({
            ...base,
            fontSize: '13px',
            backgroundColor: state.isFocused ? 'var(--gf-primary-50, #FFF4ED)' : 'transparent',
            color: 'var(--gf-secondary-700, #2D3238)',
        }),
        placeholder: (base) => ({ ...base, fontSize: '13px', color: 'var(--gf-secondary-400, #6B7280)' }),
        menu: (base) => ({ ...base, borderRadius: 10, overflow: 'hidden', zIndex: 5 }),
    };

    // The filters keep react-select's {value,label} shape so the overlay code is
    // untouched; the chip lists convert at this edge.
    const valuesOf = (arr) => (arr || []).map((e) => e.value);
    const asOptions = (vals) => vals.map((v) => ({ value: v, label: v }));

    const SITE_STAGES = [
        { key: 'siteStageOperating', label: 'Operating', toggle: () => toggleIncludeSiteStageOperating() },
        { key: 'siteStageUnderDevelopment', label: 'Under development', toggle: () => toggleIncludeSiteStageUnderDevelopment() },
        { key: 'siteStageCareAndMaint', label: 'Care & maintenance', toggle: () => toggleIncludeSiteStageCareAndMaint() },
        { key: 'siteStageShut', label: 'Shut', toggle: () => toggleIncludeSiteStageShut() },
        { key: 'siteStageProposed', label: 'Proposed', toggle: () => toggleIncludeSiteStageProposed() },
        { key: 'siteStageUndeveloped', label: 'Undeveloped', toggle: () => toggleIncludeSiteStageUndeveloped() },
    ];

    const getMinedexCommodityCategories = () => {
        return minedexCommodoties.map((e) => {
            return { label: e.commodityId, value: e.commodityId }
        });
    }

    const getMinedexTargetComodities = () => {
        return minedexTargetComodotiy.map((e) => {
            return { label: e, value: e }
        });
    }

    const getMinedexSiteTypes = () => {
        return minedexSiteType.map((e) => {
            return { label: e, value: e }
        });
    }

    const minedexCommodotyCategory = getMinedexCommodityCategories();
    const minedexTargetCommodoty = getMinedexTargetComodities();
    const minedexSiteTypes = getMinedexSiteTypes();


    const setSelectedCommodityCategories = (typesIn) => {
        setMinedexFilters({ ...minedexFilters, commodityCategory: typesIn })
    }

    const setSelectedTargetComodity = (typesIn) => {
        setMinedexFilters({ ...minedexFilters, targetCommodity: typesIn })
    }

    const setSelectedSiteType = (typesIn) => {
        setMinedexFilters({ ...minedexFilters, siteType: typesIn })
    }


    const LookupSiteCode = (e) => {
        e.preventDefault()

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        lookupSingleSiteCode(data.sitecode).then((e) => {
            // should be able to get around this by querying turf.js
            // use turn founds to fly to.
            const turfBounds = turf.bbox(e.data);
            goldfindermap.fitBounds([
                [turfBounds[0], turfBounds[1]],
                [turfBounds[2], turfBounds[3]]])
            setMinedexPopup(createSingleMinedexPopupTable(e.data.features[0], {lat:e.data.features[0].geometry.coordinates[1], lng:e.data.features[0].geometry.coordinates[0]}, setShowMinedexPopup));
        });
    };

    const toggleIncludeSiteStageUndeveloped = () => {
        setMinedexFilters({ ...minedexFilters, siteStageUndeveloped: !minedexFilters.siteStageUndeveloped });
    }
    const toggleIncludeSiteStageProposed = () => {
        setMinedexFilters({ ...minedexFilters, siteStageProposed: !minedexFilters.siteStageProposed });
    }
    const toggleIncludeSiteStageUnderDevelopment = () => {
        setMinedexFilters({ ...minedexFilters, siteStageUnderDevelopment: !minedexFilters.siteStageUnderDevelopment });
    }
    const toggleIncludeSiteStageCareAndMaint = () => {
        setMinedexFilters({ ...minedexFilters, siteStageCareAndMaint: !minedexFilters.siteStageCareAndMaint });
    }
    const toggleIncludeSiteStageOperating = () => {
        setMinedexFilters({ ...minedexFilters, siteStageOperating: !minedexFilters.siteStageOperating });
    }
    const toggleIncludeSiteStageShut = () => {
        setMinedexFilters({ ...minedexFilters, siteStageShut: !minedexFilters.siteStageShut });
    }

    return (
        // One panel. Site code lookup, the two chip lists and the legend all fit
        // in a scroll; the Simple/Advanced split only hid the site-stage
        // toggles, which are the filter people actually reach for.
        <div style={{ padding: '0 2px 8px' }}>
            {/* Site-code lookup moved to the global search box, which also
                matches on site title and short name. */}
            <FilterSection
                first
                label="Site stage"
                meta={`${SITE_STAGES.filter((st) => minedexFilters[st.key]).length} of ${SITE_STAGES.length}`}
            >
                <ChipRow>
                    {SITE_STAGES.map((st) => (
                        <Chip key={st.key} selected={!!minedexFilters[st.key]} onClick={st.toggle}>
                            {st.label}
                        </Chip>
                    ))}
                </ChipRow>
            </FilterSection>

            <FilterGroup label="Site type" summary={`${valuesOf(minedexFilters.siteType).length} of ${minedexSiteTypes.length}`}>
            <ChipMultiSelect
                meta={null}
                options={minedexSiteTypes}
                selected={valuesOf(minedexFilters.siteType)}
                onChange={(vals) => setSelectedSiteType(asOptions(vals))}
            />

            </FilterGroup>

            <FilterGroup label="Commodity category" summary={`${valuesOf(minedexFilters.commodityCategory).length} of ${minedexCommodotyCategory.length}`}>
            <ChipMultiSelect
                meta={null}
                options={minedexCommodotyCategory}
                selected={valuesOf(minedexFilters.commodityCategory)}
                onChange={(vals) => setSelectedCommodityCategories(asOptions(vals))}
            />

            </FilterGroup>

            <FilterGroup label="Target commodity" summary={`${valuesOf(minedexFilters.targetCommodity).length} selected`}>
            <FilterSection>
                <div style={{ marginTop: 9 }}>
                    <Select
                        isMulti
                        value={minedexFilters.targetCommodity}
                        onChange={setSelectedTargetComodity}
                        options={minedexTargetCommodoty}
                        styles={SelectCustomStyles}
                        placeholder="Any commodity"
                    />
                </div>
            </FilterSection>

            </FilterGroup>

            <FilterGroup label="Map icons">
            <FilterSection>
                <div style={{ marginTop: 8, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 10px' }}>
                    {minedexCommodoties.map((c) => (
                        <div key={c.commodityId} style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                            <img src={minedexSymbolDataUrl(c.commodityId)} alt=""
                                 width={14} height={14}
                                 style={{ width: 14, height: 14, flex: '0 0 14px' }} />
                            <span style={{ ...filterStyles.meta, color: 'var(--gf-secondary-600, #3A3F47)' }}>
                                {c.commodityId}
                            </span>
                        </div>
                    ))}
                </div>
            </FilterSection>
            </FilterGroup>
        </div>
    )
}
